var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
// removed import of scss-style
import ClearButton from '../clear-button/ClearButton';
class RadioButtonWithAttachment extends React.Component {
    constructor(props) {
        super(props);
        this.fileInput = React.createRef();
    }
    render() {
        const _a = this.props, { className, label, checked, onChangeHandler, onFileChangeHandler, name, value, attachmentValue, attachmentLabel, onClearAttachment } = _a, rest = __rest(_a, ["className", "label", "checked", "onChangeHandler", "onFileChangeHandler", "name", "value", "attachmentValue", "attachmentLabel", "onClearAttachment"]);
        return (React.createElement("label", { className: classnames(className, 'RadioButton RadioButtonWithAttachment', { 'RadioButtonWithAttachment--checked': checked }, { 'RadioButton--checked': checked }, {
                'RadioButtonWithAttachment--hasFileSelected': attachmentValue && attachmentValue[0]
            }) },
            label,
            React.createElement("input", Object.assign({ value: value, name: name }, rest, { type: "radio", checked: checked, onChange: onChangeHandler })),
            React.createElement("span", { className: 'RadioButton__Checkmark' }),
            React.createElement("span", { className: 'RadioButtonWithAttachment__ExpandedContent' },
                React.createElement("label", { className: 'RadioButtonWithAttachment__AttachFile' },
                    attachmentValue && attachmentValue[0]
                        ? attachmentValue[0].name
                        : attachmentLabel,
                    React.createElement("input", { ref: this.fileInput, type: "file", onChange: onFileChangeHandler }),
                    React.createElement(ClearButton, { className: 'RadioButtonWithAttachment__Clear', onClick: () => {
                            if (this.fileInput.current) {
                                this.fileInput.current.value = '';
                                this.fileInput.current.files = null;
                                onClearAttachment();
                            }
                        } })))));
    }
}
export default RadioButtonWithAttachment;
